module.exports = __webpack_public_path__ + "static/lato-latin-400.453ee82f.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-400.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-400.woff
// module chunks = 17241999800008180000